export default __webpack_public_path__ + "static/media/party-workspace-logo.ca4830e9.svg";